<script>
import appConfig from "@/app.config";

export default {
  data() {
    return {

      submitted: false,
      consuultaData: {
        cnpj: ''
      },


    }
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  mounted() {

  },
  methods: {

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true

      // remover depois de testes
      this.$router.push(`/tracking/externoped`)

      if (this.consuultaData.cnpj.length === 14 || this.consuultaData.cnpj.length === 18) {
        this.$router.push(`/tracking/externoped`)
      }
    },

  },
  page: {
    title: "tracking-externo",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
}


</script>
<template>
  <div>
    <div class="home-btn d-none d-sm-block">

    </div>
    <section class="my-5 pt-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center">
              <router-link to="/" class="d-block auth-logo">
                <img
                    src="@/assets/images/logo-dark.png"
                    alt=""
                    height="20"
                    class="auth-logo-dark mx-auto"
                />
                <img
                    src="@/assets/images/logo-light.png"
                    alt=""
                    height="20"
                    class="auth-logo-light mx-auto"
                />
              </router-link>
              <div class="row justify-content-center mt-5">
                <div class="col-sm-4">
                  <div class="maintenance-img">
                    <img
                        src="@/assets/images/coming-soon.svg"
                        alt=""
                        class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
              <h4 class="mt-5">Rastreamento de Entregas</h4>
              <p class="text-muted">
                Favor preencher seu CPF ou CNPJ para rastreio
              </p>

              <div class="row justify-content-center mt-5">


                <div class="col-md-8">

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="mb-3">
                            <input
                                id="cnpj"
                                v-model="consuultaData.cnpj"
                                type="text"
                                v-maska="consuultaData.cnpj.length > 14 ? '##.###.###/####-##' : '###.###.###-##'"
                                class="form-control text-end"
                                placeholder="CPF ou CNPJ"
                                @keypress.enter="formSubmit"
                                :class="{'is-invalid': submitted && !consuultaData.cnpj}"/>
                            <div v-if="submitted && !consuultaData.cnpj"
                                 class="invalid-feedback">
                              <span>Campo CPF/CNPJ obrigatório, favor preencher.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="mb-3">

                            <b-button variant="outline-primary" class="mx-2" @click="formSubmit"
                                      :disabled="consuultaData.cnpj.length === 14 || consuultaData.cnpj.length === 18 ? false : true" >
                              <i class="bx bx-search font-size-16 align-middle me-2"></i>
                              <span v-if="consuultaData.cnpj.length === 14">
                                Consultar Pedidos (CPF)
                              </span>
                              <span v-else-if="consuultaData.cnpj.length === 18">
                                Consultar Pedidos (CNPJ)
                              </span>
                              <span v-else>
                                Consultar Pedidos
                              </span>
                            </b-button>

                          </div>
                        </div>


                      </div>
                    </div>
                  </div>






                </div>
                <!-- end col-->
              </div>
              <!-- end row-->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
